// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"3351bdf4","253":"0a48e5ef","341":"d04918e4","438":"a3d103c0","706":"5bea9daa","726":"57fcfd63"}[chunkId] + ".chunk.js";
};